export const breakpoints = {
  desktop: 900, // TODO #12345
};
